import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {formatarCpf, formatarDataISO8601, formatarValorReal} from "../../../../utils/formatar";
import {Button, Col, FormGroup, Row} from 'reactstrap';
import moment from "moment";
import loading from '../../../../assets/images/ajax-loader.gif';
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import FontAwesome from 'react-fontawesome';

@inject("store")
@observer
export class DetalhamentoTabelaMots extends Component {

    static propTypes = {
        textoNenhumResultado: PropTypes.string,
        titulo: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
    }

    actionsTable = (cell, row, enumObject, rowIndex) => {
        const buttonType = this.appStore.width > 768 ? "icon-button " : "card-button ";
        return (
            <div>
                <Link className={"btn btn-secondary " + buttonType + "text-info"} title={"Visualizar"} to={"/detalhes-lote-pagamento/timesheet/"+row.timesheetId}><FontAwesome name={"search-plus"} /></Link>
            </div>);
    };

    getCompetencia(detalhesPagamento) {
        return detalhesPagamento && detalhesPagamento.dataGeracao ? moment(detalhesPagamento.dataGeracao).add(-1, "month").format("MM/YYYY") : "";
    }

    render() {

        const options_table = {
            noDataText: this.props.controller.loadingDetalhesPagamento ? <img src={loading} alt="loading" className="loading"/> : "Nenhuma MOT encontrada.",
        };

        return (
            <div>
                <div>
                    <h4>MOTs</h4>
                    <BootstrapTable data={ _.get(this.props.controller, "detalhesPagamento.mots", []) } maxHeight='400px' striped hover condensed options={options_table}>
                        <TableHeaderColumn width={this.appStore.width > 1000 ? 'auto' : '200'} dataField='cpf' isKey columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>CPF</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 1000 ? 'auto' : '200'} dataField='nomeCompleto' columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Nome</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 1000 ? 'auto' : '200'} dataField='cargo' columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Cargo</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 1000 ? 'auto' : '200'} dataField='competencia' columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataFormat={() => this.getCompetencia(this.props.controller.detalhesPagamento)}>Competência</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 1000 ? 'auto' : '150'} dataField='solicitacaoId' columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Solicitação</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 1000 ? 'auto' : '200'} dataField='valorTotal' columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataFormat={formatarValorReal}>Valor</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 1000 ? 'auto' : '100'} dataField='dataAdmissao' columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataFormat={formatarDataISO8601}>Admissão</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 1000 ? 'auto' : '100'} dataField='dataTermino' columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }} dataFormat={formatarDataISO8601}>Término</TableHeaderColumn>
                        <TableHeaderColumn key="actions" dataFormat={this.actionsTable} tdStyle={ {whiteSpace: 'normal', padding: 0, 'text-align': 'right', 'vertical-align': 'middle'} } />
                    </BootstrapTable>
                </div>
            </div>
        )
    }
}